import React from "react"
import { useLocation } from "react-router-dom"

import Analytics from "./Analytics";

export default function useGoogleAnalytics() {
  const location = useLocation()

  React.useEffect(() => {
    console.log('GA init being called');
    Analytics.init()
  }, [])

  React.useEffect(() => {
    console.log('GA pageview being called');
    const currentPath = location.pathname + location.search
    Analytics.sendPageview(currentPath)
  }, [location])
}